import React, { useEffect, useRef } from 'react';
import './volume.scss';

let tvScriptLoadingPromise = null;

export default function Volume() {
  const widgetContainerRef = useRef(null);

  useEffect(() => {
    if (!tvScriptLoadingPromise) {
      tvScriptLoadingPromise = new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = 'https://s3.tradingview.com/tv.js';
        script.type = 'text/javascript';
        script.onload = resolve;
        document.head.appendChild(script);
      });
    }

    tvScriptLoadingPromise.then(() => {
      if (window.TradingView && widgetContainerRef.current) {
        new window.TradingView.widget({
          container_id: 'tv_chart_container',
          autosize: true,
          symbol: 'IDX:DATA',
          interval: 'D',
          timezone: 'Etc/UTC',
          theme: 'light',
          style: '1',
          locale: 'en',
          allow_symbol_change: true,
        });
      }
    });
  }, []);

  return (
    <div className="containerVolume">
      <h3>Harga & Volume Saham</h3>

      <div className="tradingview-widget-container" style={{ width: '100%' }}>
        <div id="tv_chart_container" ref={widgetContainerRef} style={{ height: '60vh', width: '100%' }} />
      </div>
    </div>
  );
}
